import React, { useEffect, useState } from "react";
import Layout from "../../components/Layout";
import { useLocation, useNavigate } from "react-router-dom";
import { Button, Form } from "react-bootstrap";
import { useForm } from "react-hook-form";
import ToastFile from "../../utils/ToastFile";
import { addEmployee, updateEmployee } from "../../api/EmployeeApi";
import moment from "moment";
import { useRef } from "react";
import { getAllRoutebyContractor } from "../../api/RouteApi";
import ReactSelect from "react-select";
import { Controller } from "react-hook-form";

const AddUpdateEmployee = () => {
  const { state } = useLocation();
  const navigate = useNavigate();
  const [isActionEdit, setIsActionEdit] = useState(false);
  const [routes, setRoutes] = useState([]);
  const user = JSON.parse(localStorage.getItem("user"));
  const fetched = useRef(false);

  useEffect(() => {
    if (state?.employee) {
      setIsActionEdit(true);
      reset(state?.employee);
    } else {
      setIsActionEdit(false);
    }
    if (fetched.current) return;
    fetched.current = true;
    getRoute();
  }, []);

  const getRoute = () => {
    getAllRoutebyContractor(user.tenant_id)
      .then((res) => {
        if (res.status === 200) {
          const options = res?.data?.data?.routes.map((route) => ({
            value: route._id,
            label: route.routeName,
          }));
          setRoutes(options);
        } else {
          ToastFile("Failed to fetch routes", "error");
        }
      })
      .catch((err) => {
        console.error("Error fetching routes:", err);
        ToastFile("Error fetching routes", "error");
      });
  };

  const onSubmit = (data) => {
    if (isActionEdit) {
      let payload = {
        ...data,
        license_exp_date: data.license_exp_date
          ? moment(new Date(data.license_exp_date)).format("YYYY-MM-DD")
          : null,
        //routesList: data?.routesList.map((el) => el.value),
        tenant_id: user.tenant_id,
        modifiedBy: user.user_id,
        modifiedAt: new Date(),
      };
      updateEmployee(state?.employee?._id, payload)
        .then((res) => {
          if (res.status === 200) {
            ToastFile("Employee updated successfully", "updated");
            reset();
            navigate("/employees");
          } else {
            ToastFile("Failed to update employee", "error");
          }
        })
        .catch((err) => {
          console.error("Error updating employee:", err);
          ToastFile("Error updating employee", "error");
        });
    } else {
      let payload = {
        ...data,
        license_exp_date: data.license_exp_date
          ? moment(new Date(data.license_exp_date)).format("YYYY-MM-DD")
          : null,
        //routesList: data?.routesList.map((el) => el.value),
        tenant_id: user.tenant_id,
        createdBy: user.user_id,
        createdAt: new Date(),
      };
      addEmployee(payload)
        .then((res) => {
          if (res.status === 201) {
            ToastFile("Employee added successfully", "added");
            setTimeout(() => {
              navigate("/employees");
            }, 2000);
          } else {
            ToastFile("Failed to add employee", "error");
          }
        })
        .catch((err) => {
          console.error("Error adding employee:", err);
          ToastFile("Error adding employee", "error");
        });
    }
  };

  const {
    register,
    control,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm();

  return (
    <Layout>
      <div className="p-3">
        <div className="d-flex justify-content-between align-items-center mb-3">
          <span
            style={{
              fontSize: "22px",
              fontWeight: 600,
              minWidth: "140px",
            }}
          >
            {isActionEdit ? "Edit Employee" : "Add Employee"}
          </span>
        </div>

        <Form onSubmit={handleSubmit(onSubmit)}>
          <Form.Group className="mb-3">
            <Form.Label>Name</Form.Label>
            <Form.Control
              type="text"
              {...register("name", { required: true })}
              isInvalid={errors.name}
            />
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>Email</Form.Label>
            <Form.Control
              type="email"
              {...register("email", { required: true })}
              isInvalid={errors.email}
            />
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>Password</Form.Label>
            <Form.Control
              type="password"
              {...register("password", { required: true })}
              isInvalid={errors.password}
            />
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>Contact No</Form.Label>
            <Form.Control
              type="text"
              {...register("contact_no", { required: true })}
              isInvalid={errors.contact_no}
            />
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>Address</Form.Label>
            <Form.Control
              as="textarea"
              rows={3}
              {...register("address", { required: true })}
              isInvalid={errors.address}
            />
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>ABN</Form.Label>
            <Form.Control
              type="text"
              {...register("abn", { required: true })}
              isInvalid={errors.abn}
            />
          </Form.Group>
          {/* <Form.Group className="mb-3">
            <Form.Label>License No</Form.Label>
            <Form.Control
              type="text"
              {...register("license_no", { required: false })}
              isInvalid={errors.license_no}
            />
          </Form.Group> */}
          <Form.Group className="mb-3">
            <Form.Label>Driving License Exp Date</Form.Label>
            <Form.Control
              type="date"
              {...register("license_exp_date", { required: true })}
              isInvalid={errors.license_exp_date}
            />
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>Designation</Form.Label>
            <Form.Control
              type="text"
              {...register("designation", { required: true })}
              isInvalid={errors.designation}
            />
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>Select Route</Form.Label>
            <Controller
              control={control}
              name="routesList"
              rules={{ required: false }}
              render={({ field }) => {
                const selectedOptions = routes.filter((option) =>
                  field.value?.includes(option.value)
                );
                return (
                  <ReactSelect
                    {...field}
                    isMulti
                    className="py-1 rounded-0 w-25"
                    options={routes}
                    value={selectedOptions}
                    onChange={(selected) => {
                      field.onChange(selected.map(item => item.value));
                    }}
                  />
                );
              }}
            />
          </Form.Group>
          {/* <Form.Group className="mb-3">
            <Form.Label>Pay Rate</Form.Label>
            <Form.Control
              type="text"
              {...register("payrate", { required: false })}
              isInvalid={errors.payrate}
            />
          </Form.Group> */}
          <Form.Group className="mb-3">
            <Form.Label>Status</Form.Label>
            <Form.Select
              {...register("status", { required: true })}
              isInvalid={errors.status}
            >
              <option value="">Select status</option>
              <option value="Active">Active</option>
              <option value="Inactive">Inactive</option>
            </Form.Select>
          </Form.Group>
          <Button variant="primary" type="submit">
            {isActionEdit ? "Update" : "Add"}
          </Button>
          <Button
            variant="white"
            className="border-1 border-dark ms-2"
            onClick={() => navigate("/employees")}
          >
            Cancel
          </Button>
        </Form>
      </div>
    </Layout>
  );
};

export default AddUpdateEmployee;
